import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles/reset.css';
import './styles/forms.css';
import './styles/auth.css';
import './theme/theme.css';
import App from './App';
import * as Sentry from '@sentry/react';
import { env } from './utils/env';

Sentry.init({
  dsn: env.SENTRY_DSN,
  integrations: [Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
